module.exports = __webpack_public_path__ + "static/media/menu-icon-beyond-locked.b0261be0.png";